var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _vm._t("top"),
      _c(
        "el-upload",
        {
          staticClass: "upload-demo-20210810",
          attrs: {
            drag: "",
            action: "",
            "on-change": _vm.handleChange,
            "http-request": _vm.httpRequest,
            "before-upload": _vm.bjBeforeUpload,
            multiple: false,
            "file-list": _vm.fileList,
            accept: _vm.accept,
          },
        },
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _c("div", { staticClass: "el-upload__text" }, [
            _vm._v(_vm._s(_vm.$t("UploadMainText1"))),
            _c("em", [_vm._v(_vm._s(_vm.$t("UploadMainText2")))]),
          ]),
          _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [
              _vm._t("default"),
              !_vm.$slots.default
                ? [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("UploadMainHint1")) +
                        " " +
                        _vm._s(_vm.accept || _vm.acceptList.join(" ") || "") +
                        " " +
                        _vm._s(_vm.$t("UploadMainHint2")) +
                        " " +
                        _vm._s(_vm.limitSize / 1024) +
                        "Mb "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm.result.success ||
      _vm.result.error ||
      _vm.result.total ||
      _vm.result.message
        ? _c("div", { staticClass: "upload-result" }, [
            _c("p", [
              _vm.result.success
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("UploadSuccessText")) +
                        "：" +
                        _vm._s(_vm.result.success)
                    ),
                  ])
                : _vm._e(),
              _vm.result.error
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("UploadFailText")) +
                        "：" +
                        _vm._s(_vm.result.error)
                    ),
                  ])
                : _vm._e(),
              _vm.result.total
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("UploadTotalText")) +
                        "：" +
                        _vm._s(_vm.result.total)
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm.result.message
              ? _c("p", [_vm._v(_vm._s(_vm.result.message))])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }